import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import MotBookingGrid from "../../components/MotBooking/MotBookingGrid"
import MotBookingGridFilter from "../../components/MotBooking/MotBookingGridFilter"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {toggleBreakDialog, toggleTestDialog} from "./bookingSlice"

const MotBooking = () => {
    const dispatch = useAppDispatch()
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    const toggleBookingDialog = (bookingTypeID: number, state: boolean) => {
        if (bookingTypeID === 1) dispatch(toggleTestDialog(state))
        if (bookingTypeID === 2) dispatch(toggleBreakDialog(state))
    }

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Bookings</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <MotBookingGridFilter />
            <div>
                {selectedDealer && selectedDealer?.dealerId > 0 && (
                    <MotBookingGrid toggleEditBookingModal={toggleBookingDialog} />
                )}
            </div>
        </>
    )
}

export default MotBooking
